module.exports = __webpack_public_path__ + "static/media/rehab.b2e7cc82.png";